import { render } from "./RuhsatliUrunList.vue?vue&type=template&id=60bbd663"
import script from "./RuhsatliUrunList.vue?vue&type=script&lang=js"
export * from "./RuhsatliUrunList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__